// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExplorerReviews_review-container__U60aU{
    width: 83.3vw;
    height: auto;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 5vw;
    overflow-x: scroll;
    column-gap: 2.6vw;
    padding-bottom: 1vw;
}

.ExplorerReviews_review-container__U60aU::-webkit-scrollbar {
    /* display: none; */
    background-color: rgba(230,84,57,0.2);
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

.ExplorerReviews_review-container__U60aU::-webkit-scrollbar-thumb{
    background-color: #e65439;
    border-radius: 10px;
    cursor: pointer;
}

.ExplorerReviews_review-card__sNoyn{
    display: flex;
    position: relative;
    flex-direction: column;
    padding-right: 1.5vw;
    min-width: 26vw;
    height: 29vw;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 2vw;
    background-image: url("https://static.wixstatic.com/media/da937f_f48688054fa540aea4eacffec7bb1246~mv2.png/v1/fill/w_268,h_178,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(11).png");
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.ExplorerReviews_semicolon-img__0zZ9d{
    width: 3.3vw;
    height: 2.6vw;
    margin-top: 1vw;
    margin-left: 1vw;
}

.ExplorerReviews_review-trip-name__Ll-2O{
    margin-left: 1.5vw;
    font-size: 1.2vw;
    margin-bottom: 0;
    font-family: dm-sans-regular;
}

.ExplorerReviews_review-trip-month__S8Lp2{
    margin-left: 1.5vw;
    font-size: 1.1vw;
    margin-top: 0.5vw;
    font-family: dm-sans-regular;
}

.ExplorerReviews_review-trip-rating__dONmP{
    margin-left: 1.5vw;
    font-size: 1.2vw;
    font-weight: bold;
    margin-bottom: 0;
    font-family: dm-sans-regular;
}

.ExplorerReviews_review-trip-review__53n-w{
    margin-left: 1.5vw;
    font-size: 1.1vw;
    margin-top: 0.3vw;
    font-family: dm-sans-regular;
    height: 14vw;
    overflow-y:scroll;
}

.ExplorerReviews_review-trip-review__53n-w::-webkit-scrollbar {
    background-color: transparent;
    width:5px;
    height: 5px;
}

.ExplorerReviews_review-trip-review__53n-w::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
    cursor: pointer;
}

.ExplorerReviews_review-card-bottom-container__PbONz{
    display: flex;
    flex-direction: row;
    margin-left: 1.5vw;
    position: absolute;
    bottom: 0;
    margin-bottom: 1vw;
    align-items: center;
}

.ExplorerReviews_review-card-img__fxnjT{
    width: 2vw;
    height: 2vw;
}

.ExplorerReviews_review-card-reviewer__7UPJe{
    font-size: 1.2vw;
    margin-left: 1vw;
    font-family: dm-sans-regular;
}


@media(max-width: 1024px){
    .ExplorerReviews_review-container__U60aU{
        width: 95vw;
        height: auto;
        margin: auto;
        display: flex;
        flex-direction: row;
        overflow-x: scroll;
        transform: translateY(0%);
        /* justify-content: space-between; */
        margin-bottom: 5vw;
        margin-left: 5vw;
        padding-bottom: 2vw;
    }

    .ExplorerReviews_review-container__U60aU::-webkit-scrollbar{
        display: none;
    }
    
    .ExplorerReviews_review-card__sNoyn{
        display: flex;
        position: relative;
        flex-direction: column;
        padding-right: 1.5vw;
        min-width: 68vw;
        height: 84vw;
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 2vw;
        background-image: url("https://static.wixstatic.com/media/da937f_f48688054fa540aea4eacffec7bb1246~mv2.png/v1/fill/w_268,h_178,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(11).png");
        background-repeat: no-repeat;
        box-sizing: border-box;
        margin-right: 5vw;
    }
    
    .ExplorerReviews_semicolon-img__0zZ9d{
        /* width: 12.72vw;
        height: 10.94vw; */
        width: 7vw;
        height: auto;
        margin-top: 3vw;
        margin-left: 3vw;
        /* object-fit: contain; */
    }
    
    .ExplorerReviews_review-trip-name__Ll-2O{
        margin-left: 3vw;
        font-size: 3.5vw;
        margin-bottom: 0;
    }
    
    .ExplorerReviews_review-trip-month__S8Lp2{
        margin-left: 3vw;
        font-size: 3vw;
        margin-top: 0.5vw;
    }
    
    .ExplorerReviews_review-trip-rating__dONmP{
        margin-left: 3vw;
        font-size: 3.5vw;
        font-weight: bold;
        margin-bottom: 0;
    }
    
    .ExplorerReviews_review-trip-review__53n-w{
        margin-left: 3vw;
        font-size: 3vw;
        margin-right: 2vw;
        margin-top: 1vw;
        height: 40vw;
        overflow-y: scroll;
    }
    
    .ExplorerReviews_review-card-bottom-container__PbONz{
        display: flex;
        flex-direction: row;
        margin-left: 3vw;
        position: absolute;
        bottom: 0;
        margin-bottom: 5vw;
    }
    
    .ExplorerReviews_review-card-img__fxnjT{
        width: 6vw;
        height: 6vw;
    }
    
    .ExplorerReviews_review-card-reviewer__7UPJe{
        font-size: 3.5vw;
        margin-left: 2vw;
    }    
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Home/ExplorerReviews.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,gMAAgM;IAChM,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;;AAGA;IACI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,yBAAyB;QACzB,oCAAoC;QACpC,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;QACpB,eAAe;QACf,YAAY;QACZ,iCAAiC;QACjC,kBAAkB;QAClB,gMAAgM;QAChM,4BAA4B;QAC5B,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI;0BACkB;QAClB,UAAU;QACV,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ","sourcesContent":[".review-container{\n    width: 83.3vw;\n    height: auto;\n    margin: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 5vw;\n    overflow-x: scroll;\n    column-gap: 2.6vw;\n    padding-bottom: 1vw;\n}\n\n.review-container::-webkit-scrollbar {\n    /* display: none; */\n    background-color: rgba(230,84,57,0.2);\n    border-radius: 10px;\n    width: 10px;\n    height: 10px;\n}\n\n.review-container::-webkit-scrollbar-thumb{\n    background-color: #e65439;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.review-card{\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding-right: 1.5vw;\n    min-width: 26vw;\n    height: 29vw;\n    border: 1px solid rgba(0,0,0,0.1);\n    border-radius: 2vw;\n    background-image: url(\"https://static.wixstatic.com/media/da937f_f48688054fa540aea4eacffec7bb1246~mv2.png/v1/fill/w_268,h_178,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(11).png\");\n    background-repeat: no-repeat;\n    box-sizing: border-box;\n}\n\n.semicolon-img{\n    width: 3.3vw;\n    height: 2.6vw;\n    margin-top: 1vw;\n    margin-left: 1vw;\n}\n\n.review-trip-name{\n    margin-left: 1.5vw;\n    font-size: 1.2vw;\n    margin-bottom: 0;\n    font-family: dm-sans-regular;\n}\n\n.review-trip-month{\n    margin-left: 1.5vw;\n    font-size: 1.1vw;\n    margin-top: 0.5vw;\n    font-family: dm-sans-regular;\n}\n\n.review-trip-rating{\n    margin-left: 1.5vw;\n    font-size: 1.2vw;\n    font-weight: bold;\n    margin-bottom: 0;\n    font-family: dm-sans-regular;\n}\n\n.review-trip-review{\n    margin-left: 1.5vw;\n    font-size: 1.1vw;\n    margin-top: 0.3vw;\n    font-family: dm-sans-regular;\n    height: 14vw;\n    overflow-y:scroll;\n}\n\n.review-trip-review::-webkit-scrollbar {\n    background-color: transparent;\n    width:5px;\n    height: 5px;\n}\n\n.review-trip-review::-webkit-scrollbar-thumb {\n    background-color: #c4c4c4;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.review-card-bottom-container{\n    display: flex;\n    flex-direction: row;\n    margin-left: 1.5vw;\n    position: absolute;\n    bottom: 0;\n    margin-bottom: 1vw;\n    align-items: center;\n}\n\n.review-card-img{\n    width: 2vw;\n    height: 2vw;\n}\n\n.review-card-reviewer{\n    font-size: 1.2vw;\n    margin-left: 1vw;\n    font-family: dm-sans-regular;\n}\n\n\n@media(max-width: 1024px){\n    .review-container{\n        width: 95vw;\n        height: auto;\n        margin: auto;\n        display: flex;\n        flex-direction: row;\n        overflow-x: scroll;\n        transform: translateY(0%);\n        /* justify-content: space-between; */\n        margin-bottom: 5vw;\n        margin-left: 5vw;\n        padding-bottom: 2vw;\n    }\n\n    .review-container::-webkit-scrollbar{\n        display: none;\n    }\n    \n    .review-card{\n        display: flex;\n        position: relative;\n        flex-direction: column;\n        padding-right: 1.5vw;\n        min-width: 68vw;\n        height: 84vw;\n        border: 1px solid rgba(0,0,0,0.1);\n        border-radius: 2vw;\n        background-image: url(\"https://static.wixstatic.com/media/da937f_f48688054fa540aea4eacffec7bb1246~mv2.png/v1/fill/w_268,h_178,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(11).png\");\n        background-repeat: no-repeat;\n        box-sizing: border-box;\n        margin-right: 5vw;\n    }\n    \n    .semicolon-img{\n        /* width: 12.72vw;\n        height: 10.94vw; */\n        width: 7vw;\n        height: auto;\n        margin-top: 3vw;\n        margin-left: 3vw;\n        /* object-fit: contain; */\n    }\n    \n    .review-trip-name{\n        margin-left: 3vw;\n        font-size: 3.5vw;\n        margin-bottom: 0;\n    }\n    \n    .review-trip-month{\n        margin-left: 3vw;\n        font-size: 3vw;\n        margin-top: 0.5vw;\n    }\n    \n    .review-trip-rating{\n        margin-left: 3vw;\n        font-size: 3.5vw;\n        font-weight: bold;\n        margin-bottom: 0;\n    }\n    \n    .review-trip-review{\n        margin-left: 3vw;\n        font-size: 3vw;\n        margin-right: 2vw;\n        margin-top: 1vw;\n        height: 40vw;\n        overflow-y: scroll;\n    }\n    \n    .review-card-bottom-container{\n        display: flex;\n        flex-direction: row;\n        margin-left: 3vw;\n        position: absolute;\n        bottom: 0;\n        margin-bottom: 5vw;\n    }\n    \n    .review-card-img{\n        width: 6vw;\n        height: 6vw;\n    }\n    \n    .review-card-reviewer{\n        font-size: 3.5vw;\n        margin-left: 2vw;\n    }    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"review-container": `ExplorerReviews_review-container__U60aU`,
	"review-card": `ExplorerReviews_review-card__sNoyn`,
	"semicolon-img": `ExplorerReviews_semicolon-img__0zZ9d`,
	"review-trip-name": `ExplorerReviews_review-trip-name__Ll-2O`,
	"review-trip-month": `ExplorerReviews_review-trip-month__S8Lp2`,
	"review-trip-rating": `ExplorerReviews_review-trip-rating__dONmP`,
	"review-trip-review": `ExplorerReviews_review-trip-review__53n-w`,
	"review-card-bottom-container": `ExplorerReviews_review-card-bottom-container__PbONz`,
	"review-card-img": `ExplorerReviews_review-card-img__fxnjT`,
	"review-card-reviewer": `ExplorerReviews_review-card-reviewer__7UPJe`
};
export default ___CSS_LOADER_EXPORT___;
